export default __webpack_public_path__ + "static/indoor8-840dc6645e79ce4d5b99de56201fcccd.webp";